import { defineStore } from "pinia";
import { ref } from "vue";

export const useSubHeaderPropertyStore = defineStore("subHeaderPropertyStore", () => {
    const height = ref(0);

    const setHeight = (currentHeight: number) => {
        height.value = currentHeight;
    };

    return { height, setHeight };
});